import ErrorTicket from "./resolvers/ErrorTicket";
import OpenTicket from "./resolvers/OpenTicket";
import CountTicket from "./resolvers/CountTicket";
import Process from "./resolvers/Process";
import History from "./resolvers/history";


const Api = async (props) => {
    if (props.ErrorTicket) return (await ErrorTicket(props));
    if (props.OpenTicket) return (await OpenTicket(props));
    if (props.CountTicket) return (await CountTicket(props));
    if (props.Process) return (await Process(props));
    if (props.History) return (await History(props));
    return null;
}

export default Api;